const informationsCustomControls = document.querySelector('.informations-custom .controls');

if(informationsCustomControls != null){
    
    const informationsCustomControlsItems = informationsCustomControls.querySelectorAll('.item');
    
    informationsCustomControlsItems.forEach(item => {
        item.addEventListener('click', () => {
            if(item.classList.contains('plus')){
                informationsCustomControls.dataset.state = 'moins';
            }else if(item.classList.contains('moins')){
                informationsCustomControls.dataset.state = 'plus';
            }
        })
    })
}
